const INVITE_LINK_REGEX = /\/join-group\/([^?#/\s]+)/i;

export function parseInviteLink(input: string): string | null {
  if (!input) return null;
  const trimmed = input.trim();
  const match = trimmed.match(INVITE_LINK_REGEX);
  if (match && match[1]) return match[1];
  if (/^[a-zA-Z0-9_-]{8,}$/.test(trimmed)) return trimmed;
  return null;
}
